export default __webpack_public_path__ + "static/media/outline-icons.9c4845b4.svg";